<script setup>
const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  totalPages: {
    type: Number,
    required: true
  }
});
</script>

<template>
  <footer class="result-footer">
    <div class="footer-content">
      <div class="page-number">
        {{ currentPage }} / {{ totalPages }}
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.result-footer {
  width: 100%;
  padding: 15px 20px;
  background: white;
  flex-shrink: 0;
  margin-top: auto;
  
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .page-number {
      font-size: 16px;
      font-weight: 500;
      color: #666;
    }
  }
}

@media print {
  .result-footer {
    page-break-inside: avoid;
  }
}
</style>